<script setup>
import { ref, computed, onMounted, onUnmounted } from 'vue';

const props = defineProps({
  assignedAt: { type: String, default: null },
  idleMins: { type: Number, default: null },
  compact: { type: Boolean, default: false },
});

const now = ref(Date.now());
const countdownTitle = 'Tempo antes do próximo rodízio';
let timer = null;

onMounted(() => {
  timer = setInterval(() => {
    now.value = Date.now();
  }, 1000);
});

onUnmounted(() => {
  if (timer) clearInterval(timer);
});

const secondsRemaining = computed(() => {
  if (!props.assignedAt) return null;
  const assigned = new Date(props.assignedAt).getTime();
  const elapsed = (now.value - assigned) / 1000;
  const propIdleMins = Number(props.idleMins);
  const idleMins = Number.isFinite(propIdleMins) && propIdleMins > 0 ? propIdleMins : 4;
  const remaining = idleMins * 60 - elapsed;
  return Math.max(0, Math.floor(remaining));
});

// Só exibe se o timer estiver ativo (assigned_at existe e ainda não expirou).
// remaining é clampado em 0, então exigir > 0 evita "0:00" preso na tela em
// conversas que o rodízio não circula mais (respondidas/ancoradas).
const visible = computed(
  () => secondsRemaining.value !== null && secondsRemaining.value > 0
);

const display = computed(() => {
  if (secondsRemaining.value === null) return '';
  const m = Math.floor(secondsRemaining.value / 60);
  const s = secondsRemaining.value % 60;
  return `${m}:${s.toString().padStart(2, '0')}`;
});

// Verde >2min, laranja 1-2min, vermelho <1min (pisca)
const urgencyClass = computed(() => {
  const s = secondsRemaining.value;
  if (s === null) return '';
  if (s <= 60) return 'rodizio-urgent';
  if (s <= 120) return 'rodizio-warning';
  return 'rodizio-ok';
});
</script>

<template>
  <span
    v-if="visible"
    class="rodizio-countdown"
    :class="[urgencyClass, compact ? 'rodizio-compact' : '']"
    :title="countdownTitle"
  >
    <fluent-icon icon="timer" size="10" class="rodizio-icon" />
    {{ display }}
  </span>
</template>

<style scoped>
.rodizio-countdown {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  font-size: 10px;
  font-weight: 700;
  border-radius: 999px;
  padding: 1px 6px 1px 4px;
  line-height: 16px;
  white-space: nowrap;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.02em;
}
.rodizio-compact {
  font-size: 9px;
  padding: 0px 4px 0px 3px;
  line-height: 14px;
}
.rodizio-icon {
  flex-shrink: 0;
}
.rodizio-ok {
  background: #dcfce7;
  color: #15803d;
}
.rodizio-warning {
  background: #fef3c7;
  color: #b45309;
}
.rodizio-urgent {
  background: #fee2e2;
  color: #dc2626;
  animation: rodizio-pulse 1s ease-in-out infinite;
}
@keyframes rodizio-pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
